<div class="itk"
  [attr.id]="id || null"
  [ngClass]="classes"
  [class.itk--linked]="linked"
  [class.is-active]="active">
  @if (displayItems.length > 1) {
    <div class="itk__items slick-slider">
      <ngx-slick-carousel
        class="itk__carousel"
        [config]="slideConfig"
        (beforeChange)="beforeChange($event)">
        @for (item of displayItems; track $index) {
          <div ngxSlickItem class="itk__item">
            <div class="itk__item-icon">
              <img src="/assets/0/favicon/favicon-black.svg" class="icon icon--sm" alt="">
            </div>
            <div class="itk__item-content" [innerHTML]="'<strong>Important to know</strong> ' + (item || '')"></div>
          </div>
        }
      </ngx-slick-carousel>
      <div class="itk__counter">{{ currentSlide + 1 }} / {{ displayItems.length }}</div>
    </div>
  } @else {
    <div class="itk__items">
      <div class="itk__item">
        <div class="itk__item-icon">
          <img src="/assets/0/favicon/favicon-black.svg" class="icon icon--sm" alt="">
        </div>
        <div class="itk__item-content" [innerHTML]="'<strong>Important to know</strong> ' + (displayItems[0] || '')"></div>
      </div>
    </div>
  }
</div>